module.exports = __webpack_public_path__ + "static/media/a9.c920daa3.jpg";